/* istanbul ignore file */
import fetch from '../Http/fetch';

export default class ToastApi {
    static async loadFromServer() {
        return fetch('/_toasts')
            .then(({ response }) => response.json().then((body) => ({ response, body })));
    }
}
